SupportServiceActionsBaseView = require('./service_action_base')
SupportServiceActionButtonTemplate = require('../../../../service_action_button.html.mustache')
SupportMultipleQtyPopupView = require('../../multiple_Qty_Popup_View')

class SupportReturnItemsServiceActionView extends SupportServiceActionsBaseView
  id: 'return_item'

  initialize: ->
    _.bindAll.apply(_, [this].concat(_.functions(this)))
    @I18nScope = 'modules.support'
    @template = SupportServiceActionButtonTemplate
    @order = Groupon.Support.currentOrder

  render: ->
    @$el.append toHtml(@template, @toHash(), @I18nScope)

  toHash: ->
    button_title = if @order.groupons?.length > 1 then I18n.t("js.modules.support.return_all_items") else I18n.t("js.modules.support.return_item")
    hash =
      service_action_id : "return_item",
      service_action : button_title
    @extendHash(hash)

  actionHandler: (event)->
    currentOrder = Groupon.Support.currentOrder

    if window.showMultiReturnItemPopup and currentOrder.groupons?.length > 1
      args =
        orders: @order
        serviceActionName: 'return_item'
        singleActionButtonCallback: @getUrlForVoucher
        groupActionButtonCallback: @getUrlForAllVouchers
        showgroupActionButton: false
        title: I18n.t("js.modules.support.return_all_items")
        singleActionButtonName: I18n.t("js.modules.support.return_item")
        groupActionButtonName: I18n.t("js.modules.support.return_all_items")
      multipleQtyPopup = new SupportMultipleQtyPopupView(args)
      multipleQtyPopup.render()
    else
      openLocation currentOrder.returnItemUrl

    return true

  getUrlForAllVouchers:(order_id)->
    return null

  getUrlForVoucher: (groupon) ->
    groupon.returnItemUrl

  events :
    "click #return_item"  : "actionHandler"

module.exports = SupportReturnItemsServiceActionView
